import React, { useState, useEffect } from 'react';
import { PanelType, Persona, PersonaSize, Panel } from '@fluentui/react';
import { Dropdown, Spin } from 'antd';
import './Header.css';
import MenuBlackIcon from '../SVG/MenuBlackIcon';
import MenuMainIcon from '../SVG/MenuMainIcon';
import MenuBack from '../SVG/MenuBack';
import QuestionIcon from './QuestionIcon';
// import NotificationIcon from './NotificationIcon';
import MenuLogo from '../SVG/MenuLogo';
import FeedbackIcon from './FeedbackIcon';
import { Dialog, DialogType } from '@fluentui/react';
import FeedbackCart from './FeedbackCart';
import { smile, neutral, sad } from '../../Image/base64Image';
import FieldTextArea from '../../Components/FieldTextArea/FieldTextArea';
import ButtonDefault from '../../Components/ButtonDefault/ButtonDefault';
import moment from 'moment';

const Header = (props) => {

    const [showMenu, setShowMenu] = useState(false);
    const [backPath, setBackPath] = useState();

    const [items, setItems] = useState([]);
    const [feedbackId, setFeedbackId] = useState();
    const [showFeedback, setShowFeedback] = useState(false);
    const [feedbackStep, setFeedbackStep] = useState(1);
    const [feedbackNote, setFeedbackNote] = useState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {

        let tBackPath = '';
        if (props?.pathname) {
            let tPath = props?.pathname?.split('/');
            if (tPath.length >= 1) {

                if (props?.type == "next") {
                    if (tPath.length > 3) {
                        tPath.pop();
                        tBackPath = tPath.join('/');
                    }
                } else {
                    if (tPath.length > 4) {
                        tPath.pop();
                        tPath.pop();
                        tBackPath = tPath.join('/');
                    }
                }

            }
        }

        setBackPath(tBackPath);
    }, [props?.pathname]);

    useEffect(() => {
        if (props?.feedbackUnixId > 0) {
            onPressFeedback(props?.feedbackUnixId);
        }
    }, [props?.feedbackUnixId])

    useEffect(() => {

        let tItems = [{
            key: '0',
            label: (
                <div onClick={() => {
                    if (props?.onPasswordChange) {
                        props?.onPasswordChange(true);
                    }
                }}>
                    Нууц үг солих
                </div>
            )
        }];

        if (props?.userMenu?.length > 0) {
            tItems = [...tItems, ...props?.userMenu];
        }

        tItems.push({
            type: 'divider',
        });

        tItems.push({
            key: '1',
            label: (
                <div onClick={logOut}>
                    Гарах
                </div>
            )
        });


        tItems?.map((r, index) => {
            r.key = index?.toString();
        });

        setItems(tItems);
    }, [props?.userMenu]);

    const logOut = () => {
        localStorage.removeItem('userInfo');
        if (props?.type == "next") {
            props.navigate.push("/");
        } else {
            window.location.reload();
        }
    }

    const onPressMenu = () => {
        setShowMenu(r => !r);
    }

    const onPressQuestion = () => {
        window.open("https://diwo.tawk.help/", "_blank");
    }

    const onPressFeedback = (pUnixId) => {
        setFeedbackId(pUnixId ? pUnixId : moment().unix());
        setFeedbackStep(1);
        setShowFeedback(r => r = !r);
    }

    const onPressBack = () => {
        if (props?.navigate) {
            if (props?.type == "next") {
                props.navigate.push(backPath);
            } else {
                if (props?.location?.state?.backurl) {
                    props.navigate(backPath);
                } else {
                    props.navigate(-1);
                }
            }
        }
    }

    const onPressFeedbackCart = async (pType) => {
        if (props?.onFeedback) {
            try {
                setLoading(true);
                await props.onFeedback(feedbackId, "type", pType);
            } finally {
                setLoading(false);
            }
        }
        setFeedbackStep(2);
    }

    const onSentFeedback = async () => {
        if (props?.onFeedback && feedbackNote) {
            try {
                setLoading(true);
                await props.onFeedback(feedbackId, "note", feedbackNote);
            } finally {
                setLoading(false);
            }
        }
        setShowFeedback(false);
    }

    return (
        <div>
            <div style={{
                width: '100%',
                height: '48px',
                backgroundColor: "#3E2FA0",
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', marginLeft: 14 }}>
                    {backPath ? (
                        <div onClick={onPressBack} style={{ cursor: 'pointer', marginRight: 16, alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
                            <MenuBack />
                        </div>
                    ) : null}
                    <div onClick={onPressMenu} style={{ cursor: 'pointer', alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
                        <MenuLogo />
                    </div>
                    <div style={{ marginLeft: 22, alignItems: 'center', justifyContent: 'center', display: 'flex', fontSize: 14, fontWeight: 'bold', color: "#FFFFFF" }}>
                        {props?.userInfo?.companyname?.substring(0, 60)}{props?.userInfo?.companyname?.length > 60 && "..."}
                    </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', marginRight: 16 }}>
                    {/* <div style={{ height: 20, cursor: 'pointer' }}>
                        <NotificationIcon />
                    </div> */}
                    <div onClick={onPressQuestion} style={{ cursor: 'pointer', height: 20, margin: '0px 16px' }}>
                        <QuestionIcon />
                    </div>
                    <div onClick={() => onPressFeedback()} style={{ cursor: 'pointer', height: 20, marginRight: 16 }}>
                        <FeedbackIcon />
                    </div>
                    <div style={{ cursor: 'pointer' }}>
                        <Dropdown
                            overlayStyle={{
                                minWidth: 130,
                                zIndex: 9999999
                            }}
                            menu={{
                                items,
                            }}
                            trigger={['click']}>
                            <Persona hidePersonaDetails text={props?.userInfo?.fullname} size={PersonaSize.size32} />
                        </Dropdown>
                    </div>
                </div>
            </div>
            <Panel
                headerText='diwo'
                isOpen={showMenu}
                onDismiss={onPressMenu}
                hasCloseButton={false}
                isLightDismiss={true}
                type={PanelType.smallFixedNear}
                isFooterAtBottom={true}
                onRenderHeader={() => {
                    return (
                        <div onClick={onPressMenu} style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: 36, justifyItems: 'center', cursor: 'pointer' }}>
                            <div style={{ marginLeft: 24 }}>
                                <MenuBlackIcon />
                            </div>
                            <div style={{ fontWeight: 'bold', fontSize: 14, marginLeft: 10 }}>
                                diwo
                            </div>
                        </div>
                    );
                }}
            >
                <div onClick={() => {
                    setShowMenu(false);
                }}
                    style={{ display: 'flex', marginBottom: 26, cursor: 'pointer', alignItems: 'center' }}>
                    <div>
                        <MenuMainIcon />
                    </div>
                    <div style={{ marginLeft: 10 }}>
                        Хүний нөөцийн систем
                    </div>
                </div>
            </Panel>
            <Dialog
                hidden={!showFeedback}
                onDismiss={() => {
                    setShowFeedback(false);
                }}
                dialogContentProps={{
                    title: 'Санал',
                    type: DialogType.close
                }}
            >
                {loading ? <div style={{ marginTop: 50, minWidth: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Spin /></div> : (feedbackStep == 1 ? (
                    <div style={{ display: 'flex' }}>
                        <div style={{ marginRight: 12 }}>
                            <FeedbackCart onClick={() => onPressFeedbackCart("Таалагдаж байна")} text="Таалагдаж байна" icon={<img width={28} height={28} src={smile} alt='' />} />
                        </div>
                        <div>
                            <FeedbackCart onClick={() => onPressFeedbackCart("Яахав дээ л байна")} text="Яахав дээ л байна" icon={<img width={28} height={28} src={neutral} alt='' />} />
                        </div>
                        <div style={{ marginLeft: 12 }}>
                            <FeedbackCart onClick={() => onPressFeedbackCart("Таалагдахгүй байна")} text="Таалагдахгүй байна" icon={<img width={28} height={28} src={sad} alt='' />} />
                        </div>
                    </div>
                ) : (
                    <div style={{ minWidth: 300 }}>
                        <FieldTextArea onChanged={(pValue) => { setFeedbackNote(pValue); }} placeholder="Саналаа бичнэ үү." />
                        <div style={{ marginTop: 16, display: 'flex', justifyContent: 'flex-end' }}>
                            <ButtonDefault onClick={onSentFeedback} text="Илгээх" />
                        </div>
                    </div>
                ))}
            </Dialog>
        </div>
    );
}

export default Header;